import * as actionTypes from "./actionTypes";

const ALL_FILTER = {
  route_id: "ALL",
  route_name: "ALL",
  db_name: "ALL",
  db_id: "",
};

const initialState = {
  routes: [],
  filteredRoutes: [],
  selectedRouteId: ALL_FILTER.route_id,
  switchDbId: null,
  loading: true,
  draftRoutes: {},
  expandedState: false,
  showSwitchDbConfirmModal: false,
  isCurrentDeliveryTab: true,
  isSearchEnabled: false,
  error: null,
};

export const actions = {
  fetchData: (routeId, isCurrentDeliveryTab) => ({
    type: actionTypes.FETCH_DELIVERY_ROUTES_REQ,
    routeId,
    isCurrentDeliveryTab,
  }),
  fetchDataSuccess: (data) => ({
    type: actionTypes.FETCH_DELIVERY_ROUTES_SUCCESS,
    payload: data,
  }),
  fetchDataFail: (error) => ({
    type: actionTypes.FETCH_DELIVERY_ROUTES_FAIL,
    error,
  }),
  setLoading: (value) => ({
    type: actionTypes.SET_DELIVERY_ROUTES_LOADING,
    value,
  }),
  selectRoute: (routeId) => ({
    type: actionTypes.SELECT_DELIVERY_ROUTE,
    routeId,
  }),
  updateDraftRoutes: (draftRoutes) => ({
    type: actionTypes.UPDATE_DRAFT_ROUTES,
    draftRoutes,
  }),
  toggleExpandState: () => ({
    type: actionTypes.TOGGLE_EXPAND_STATE,
  }),
  setSwitchDbId: (dbId) => ({
    type: actionTypes.SET_SWITCH_DB_ID,
    dbId,
  }),
  toggleSwitchDbConfirmModal: (visible) => ({
    type: actionTypes.TOGGLE_SWITCH_DB_CONFIRM_MODAL,
    visible,
  }),
  setCurrentDeliveryTab: (isCurrentDeliveryTab) => ({
    type: actionTypes.SET_CURRENT_DELIVERY_TAB,
    isCurrentDeliveryTab,
  }),
  toggleSearchEnabled: (enabled) => ({
    type: actionTypes.TOGGLE_SEARCH_ENABLED,
    enabled,
  }),
  filterRoutesBySearch: (searchText, routes) => ({
    type: actionTypes.FILTER_ROUTES_BY_SEARCH,
    searchText,
    routes,
  }),
  assignTouchpointBulk: (data, isCurrentDeliveryTab) => ({
    type: actionTypes.ASSIGN_TOUCHPOINT_BULK_REQ,
    data,
    isCurrentDeliveryTab,
  }),
  assignTouchpointBulkSuccess: () => ({
    type: actionTypes.ASSIGN_TOUCHPOINT_BULK_SUCCESS,
  }),
  assignTouchpointBulkFail: (error) => ({
    type: actionTypes.ASSIGN_TOUCHPOINT_BULK_FAIL,
    error,
  }),
  updateDbRoute: (payload) => ({
    type: actionTypes.UPDATE_DB_ROUTE_REQ,
    payload,
  }),
  updateDbRouteSuccess: () => ({
    type: actionTypes.UPDATE_DB_ROUTE_SUCCESS,
  }),
  updateDbRouteFail: (error) => ({
    type: actionTypes.UPDATE_DB_ROUTE_FAIL,
    error,
  }),
  resetState: () => ({
    type: actionTypes.RESET_DELIVERY_ROUTES_STATE,
  }),
};

const cpDeliveryRoutesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_DELIVERY_ROUTES_REQ:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.FETCH_DELIVERY_ROUTES_SUCCESS:
      return {
        ...state,
        routes: action.payload || [],
        filteredRoutes: action.payload || [],
        loading: false,
        error: null,
      };
    case actionTypes.FETCH_DELIVERY_ROUTES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case actionTypes.SET_DELIVERY_ROUTES_LOADING:
      return {
        ...state,
        loading: action.value,
      };
    case actionTypes.SELECT_DELIVERY_ROUTE:
      return {
        ...state,
        selectedRouteId: action.routeId,
        draftRoutes: {},
        expandedState: false,
        isSearchEnabled: false,
      };
    case actionTypes.UPDATE_DRAFT_ROUTES:
      return {
        ...state,
        draftRoutes: action.draftRoutes,
      };
    case actionTypes.TOGGLE_EXPAND_STATE:
      return {
        ...state,
        expandedState: !state.expandedState,
      };
    case actionTypes.SET_SWITCH_DB_ID:
      return {
        ...state,
        switchDbId: action.dbId,
      };
    case actionTypes.TOGGLE_SWITCH_DB_CONFIRM_MODAL:
      return {
        ...state,
        showSwitchDbConfirmModal: action.visible,
      };
    case actionTypes.SET_CURRENT_DELIVERY_TAB:
      return {
        ...state,
        isCurrentDeliveryTab: action.isCurrentDeliveryTab,
        draftRoutes: {},
        expandedState: false,
        isSearchEnabled: false,
      };
    case actionTypes.TOGGLE_SEARCH_ENABLED:
      return {
        ...state,
        isSearchEnabled: action.enabled,
      };
    case actionTypes.FILTER_ROUTES_BY_SEARCH:
      if (!action.searchText) {
        return {
          ...state,
          filteredRoutes: action.routes,
        };
      }
      
      const searchLower = action.searchText.toLowerCase();
      
      const filteredData = {
        active_routes: action.routes?.active_routes,
        assigned_routes: action.routes?.assigned_routes,
        misroute_count: action.routes?.misroute_count,
        dbs_to_switch: action.routes?.dbs_to_switch,
        unassigned_count: action.routes?.unassigned_count,
        touchpoints: action.routes?.touchpoints?.filter((r) => {
          return (
            r?.cx_address?.toLowerCase().includes(searchLower) ||
            r?.cx_name?.toLowerCase().includes(searchLower) ||
            r?.cx_phone_number?.includes(action.searchText)
          );
        }),
      };
      
      return {
        ...state,
        filteredRoutes: filteredData,
      };
    case actionTypes.ASSIGN_TOUCHPOINT_BULK_REQ:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.ASSIGN_TOUCHPOINT_BULK_SUCCESS:
      return {
        ...state,
        draftRoutes: {},
        loading: false,
        isSearchEnabled: false,
      };
    case actionTypes.ASSIGN_TOUCHPOINT_BULK_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case actionTypes.UPDATE_DB_ROUTE_REQ:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.UPDATE_DB_ROUTE_SUCCESS:
      return {
        ...state,
        switchDbId: null,
        showSwitchDbConfirmModal: false,
        loading: false,
      };
    case actionTypes.UPDATE_DB_ROUTE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case actionTypes.RESET_DELIVERY_ROUTES_STATE:
      return initialState;
    default:
      return state;
  }
};

cpDeliveryRoutesReducer.initialState = initialState;
export default cpDeliveryRoutesReducer;
